import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Button from '../Button/index.js';
import Glyphicon from '../Glyphicon/index.js';

/**
 *  Trigger for use in ExpandSelector, Collapsible, and other show/hide uses
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ExpandTrigger(_ref) {
  let {
    isCollapsed,
    onClick,
    collapsed = {
      label: 'See More',
      glyph: 'chevron-down'
    },
    expanded = {
      label: 'See Less',
      glyph: 'chevron-up'
    },
    className,
    ...rest
  } = _ref;
  // Destructure the appropriate configuration set
  const {
    label,
    glyph
  } = isCollapsed ? collapsed : expanded;
  return /*#__PURE__*/_jsxs(Button, {
    ...rest,
    className: clsx(className, 'text-center display-block margin-horizontal-auto'),
    bsStyle: "text",
    onClick: onClick,
    children: [label, /*#__PURE__*/_jsx(Glyphicon, {
      glyph: glyph,
      className: "margin-left-2 font-size-200"
    })]
  });
}
export default ExpandTrigger;